<template>
  <layout-mobile>
    <tabs-mobile v-model="activeTab">
      <b-tab-item>
        <template #header>
          Tasks
          <badge-default
            v-if="tasksBadge"
            :count="tasksBadge"
            class="ml-25"
          ></badge-default>
        </template>

        <up-next-tasks-mobile-tab></up-next-tasks-mobile-tab>
      </b-tab-item>

      <b-tab-item label="Appointments">
        <up-next-appointments-mobile-tab></up-next-appointments-mobile-tab>
      </b-tab-item>
    </tabs-mobile>
  </layout-mobile>
</template>

<script>
import UpNextTasksMobileTab from "./UpNextTasksMobileTab";
import UpNextAppointmentsMobileTab from "./UpNextAppointmentsMobileTab";
import TabsMobile from "../../components/tab/TabsMobile";

export default {
  name: "UpNextPageMobile",
  components: {
    TabsMobile,
    UpNextAppointmentsMobileTab,
    UpNextTasksMobileTab,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    tasksBadge() {
      return this.$store.getters.tasksBadge;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

::v-deep {

  .tabs li.is-active a {
    border-bottom-color: #1C6C7D;
    color: #1C6C7D;
  }

  .tabs a {
    border-width: 4px;
    padding: 0.25rem 0.5rem 0.5rem;
    line-height: 18px;
  }
}
</style>
